// Internal modules
import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION } from './graphql';
import type {
  CreateBankAccountCandidateMutation,
  CreateBankAccountCandidateMutationVariables,
} from '@/generated/graphql';

/**
 * @function createBankAccountCandidate
 * @param {object} payload
 * @returns {Promise}
 * @description Creates a bank account candidate
 */
const createBankAccountCandidate = (
  variables: CreateBankAccountCandidateMutationVariables,
): Promise<void> => {
  const { api: apiActions, ui: uiActions } = appStore.getActions();
  return apolloClient
    .mutate<
      CreateBankAccountCandidateMutation,
      CreateBankAccountCandidateMutationVariables
    >({
      mutation: CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION,
      variables,
    })
    .then(({ data }) => {
      // @ts-expect-error TODO data could be undefined
      const { addBankCandidate } = data;
      apiActions.setBankCandidateData(addBankCandidate);
      uiActions.toggleIsFormSubmitting(false);
      uiActions.toggleIsSepaInterstitialOpen(true);
    })
    .catch(error => {
      uiActions.toggleIsFormSubmitting(false);
    });
};

export { createBankAccountCandidate };
